import React from 'react';
import { Modal, View, TouchableOpacity, Text, StyleSheet, Image } from 'react-native';

interface ImageViewerProps {
  images: { uri: string }[];
  imageIndex: number;
  visible: boolean;
  onRequestClose: () => void;
}

// Web用の簡易版画像ビューアー
export const ImageViewer: React.FC<ImageViewerProps> = ({
  images,
  imageIndex,
  visible,
  onRequestClose,
}) => {
  if (!visible) return null;

  return (
    <Modal visible={visible} transparent={true} onRequestClose={onRequestClose}>
      <View style={styles.container}>
        <TouchableOpacity style={styles.closeButton} onPress={onRequestClose}>
          <Text style={styles.closeText}>×</Text>
        </TouchableOpacity>
        <Image
          source={{ uri: images[imageIndex]?.uri }}
          style={styles.image}
          resizeMode="contain"
        />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.9)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: 40,
    right: 20,
    zIndex: 1,
    padding: 10,
  },
  closeText: {
    color: 'white',
    fontSize: 40,
  },
  image: {
    width: '90%',
    height: '90%',
  },
});
